import { FlatList, Image } from "react-native"
import { view_styles } from "../../constants/styles"
import { Icons } from "../../Components"
import Colors from "../../constants/colors"
import type { PublicPlayerProps, SquareProps, SquareResultProps } from "../../types"
import React, { useState } from "react"
import { Button, Text, View } from "../../Components/Themed"
import { useColors } from "../../constants/useColors"

type ResultCardProps = {
    square_results:SquareResultProps[],
    squares:SquareProps[],
    hidden?:boolean,
    disable_collapse?:boolean,
    home_abbr?:string,
    away_abbr?:string,
    onPlayerSelect:(player:PublicPlayerProps) => void
}

const ResultsCard = ({ hidden, disable_collapse, square_results, squares, home_abbr, away_abbr, onPlayerSelect }:ResultCardProps) => {
    const C = useColors();
    const [ expanded, setExpanded ] = useState(true);

    const renderResults = (data: { item:SquareResultProps, index:number }) => {
        if(!data.item.playerDetails){ return <></> }
        const square = squares.find(s => s.sq_square_id == data.item.sq_square_id);
        return (
            <Button transparent style={{ ...view_styles.body_row, padding:10, borderBottomWidth:1, borderColor:C.borders.light }} onPress={() => onPlayerSelect(data.item.playerDetails)}>
                <View transparent style={{ marginRight:10 }}>
                    <Text theme="h2">Q{data.item.iteration_num}</Text>
                </View>
                <Image
                    source={{ uri: data.item.playerDetails.profile_pic && data.item.playerDetails.profile_pic != '' ? data.item.playerDetails.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:40, width:40, borderRadius:100 }}
                    resizeMode="cover"
                />
                <View transparent style={{ flex:1, marginLeft:5 }}>
                    <Text theme="h2">@{data.item.playerDetails.username}</Text>
                    {square ?
                    <Text style={{ marginTop:3 }} theme='description'>{home_abbr}: {square.square_score_x}, {away_abbr}: {square.square_score_y}</Text>
                    :<></>}
                </View>
                <View style={{ paddingLeft:5, paddingRight:5 }}>
                    <Text size={14} color={C.text.success} weight='bold'>${data.item.winnings.toFixed(2)}</Text>
                </View>
            </Button>
        )
    }

    if(hidden){ return <></> }

    return (
        <View float style={{ minWidth:350 }}>
            <Button disabled={disable_collapse} transparent style={{ flexDirection:'row', alignItems:'center' }} onPress={() => setExpanded(!expanded)}>
                <Icons.TrophyIcon size={18} color={Colors.incentive.gold} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>WINNERS</Text>
                    <Text style={{ marginTop:3 }} theme="description">See the winners of past quarters</Text>
                </View>
                {!disable_collapse ?
                <Icons.ChevronIcon direction={true?'down':'up'} size={8} color={C.text.h1} />
                :<></>}
            </Button>
            {expanded ?
            <View transparent style={view_styles.section_body}>
                <FlatList
                    data={square_results.sort((a,b) => a.iteration_num - b.iteration_num)}
                    renderItem={renderResults}
                    keyExtractor={(item) => item.squares_result_id.toString()}
                />
            </View>
            :<></>}
        </View>
    )
}

export default ResultsCard